import React from 'react';

/**
 * Not a React Native Pressable. Pressable drops `onPress` when the editor
 * selection changes during the gesture, so Apply did nothing while text was
 * selected. A button click still runs, and mouse down does not move the caret.
 */
export function LinkApplyButton({
  onApply,
  testID = 'pd-richtext-link-apply',
}: {
  onApply: () => void;
  testID?: string;
}): React.JSX.Element {
  return (
    <button
      type="button"
      data-testid={testID}
      aria-label="Apply link"
      onPointerDown={event => {
        event.preventDefault();
      }}
      onMouseDown={event => {
        event.preventDefault();
      }}
      onClick={onApply}
      style={{
        backgroundColor: '#1D4ED8',
        color: '#FFFFFF',
        fontWeight: 600,
        border: 'none',
        borderRadius: 4,
        padding: '10px 12px',
        cursor: 'pointer',
      }}
    >
      Apply
    </button>
  );
}
